import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import useStyles from "./EVESensitivity.styles";
import { HedgeRatioProvider } from "../../../context/HedgeRatioContext";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import EVESensitivityFiltersAndReports from "./EVESensitivityFiltersAndReports.component";
import { ApprovalProvider } from "../../../context/ApprovalContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const EVESensitivity = ({ toCompare = false } = {}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container item spacing={2}>
        <HedgeRatioProvider>
          <ApprovalProvider>
            <EVESensitivityFiltersAndReports
              toSave={true}
              toCompare={toCompare}
              toDisableEntitySelection={false}
              reportLocated={"LEFT"}
            />
          </ApprovalProvider>
        </HedgeRatioProvider>
        {toCompare && (
          <HedgeRatioProvider>
            <ApprovalProvider>
              <EVESensitivityFiltersAndReports
                toSave={false}
                toCompare={toCompare}
                toDisableEntitySelection={true}
                reportLocated={"RIGHT"}
              />
            </ApprovalProvider>
          </HedgeRatioProvider>
        )}
        <Grid size={{ xs: 12, md: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default EVESensitivity;
